import { render, staticRenderFns } from "./CFileManagerMenuItem.vue?vue&type=template&id=7a3ddc86&scoped=true&"
import script from "./CFileManagerMenuItem.vue?vue&type=script&lang=ts&"
export * from "./CFileManagerMenuItem.vue?vue&type=script&lang=ts&"
import style0 from "./CFileManagerMenuItem.vue?vue&type=style&index=0&id=7a3ddc86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3ddc86",
  null
  
)

export default component.exports